var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5C14.448 6.5 14 6.052 14 5.5V4H10V5.5C10 6.052 9.552 6.5 9 6.5C8.448 6.5 8 6.052 8 5.5V4C8 2.897 8.897 2 10 2H14C15.103 2 16 2.897 16 4V5.5C16 6.052 15.552 6.5 15 6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5V13.42C18 13.83 17.66 14.17 17.25 14.17C16.84 14.17 16.5 13.83 16.5 13.42V12.5H7.5V13.42C7.5 13.83 7.16 14.17 6.75 14.17C6.34 14.17 6 13.83 6 13.42V12.5H0V19.25C0 20.77 1.23 22 2.75 22H21.25C22.77 22 24 20.77 24 19.25V12.5H18ZM21.25 5H2.75C1.23 5 0 6.23 0 7.75V11H6V9.75C6 9.34 6.34 9 6.75 9C7.16 9 7.5 9.34 7.5 9.75V11H16.5V9.75C16.5 9.34 16.84 9 17.25 9C17.66 9 18 9.34 18 9.75V11H24V7.75C24 6.23 22.77 5 21.25 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.268c0268dcec8ce39374bb0eb17bf6f9.svg";
export { ForwardRef as ReactComponent };